module.exports = __webpack_public_path__ + "static/media/contact2.b637e670.jpg";